import axiosInstance from "./axiosInstance";

const base = `/api/v1/hotel/restricted-access`;

export const fetchRestrictedAccessStatus = async () => {
    const response = await axiosInstance.get(base);
    return response.data?.data;
};

export const verifyRestrictedAccessPassword = async (password) => {
    const response = await axiosInstance.post(`${base}/verify`, { password });
    return response.data?.data;
};
